import React from "react";
import { Row, Col, FormGroup } from "react-bootstrap";

import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import Label from "app/Components/_form/Label/Label";

import InputError from "app/Components/_form/InputError/InputError";
import FormInput from "app/Components/_form/FormInput/FormInput";
import {
  employeeFormLabel,
  employeeGenderList,
  employeeTrainingDesignationList,
} from "../Constant";
import { siteTypeList } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import InitialTrainingForm from "./InitialTrainingForm";
import InitialMedicalForm from "./InitialMedicalForm";
import {
  disableFutureDate,
  endDateValidation,
  nextYearDateDate,
} from "app/_helpers/dateHelper";
import InitialLocationForm from "./InitialLocationForm";

function EmployeeForm({
  form = {},
  onChange,
  error = {},
  siteList = [],

  id,
  previousTraining,
  setPreviousTraining,
  preTrainingErr,
}) {
  // ********** Date Validation ************ //

  // console.log("form", form);
  // console.log("error", error);

  return (
    <div>
      <div>
        <h5>Basic Details</h5>
        <Row>
          <Col md={4}>
            <FormInput
              name={"firstName"}
              value={form.firstName}
              onChange={onChange}
              label={employeeFormLabel["firstName"]}
              placeHolder={employeeFormLabel["firstName"]}
              error={error["firstName"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"middleName"}
              value={form.middleName}
              onChange={onChange}
              label={employeeFormLabel["middleName"]}
              placeHolder={employeeFormLabel["middleName"]}
              error={error["middleName"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"lastName"}
              value={form.lastName}
              onChange={onChange}
              label={employeeFormLabel["lastName"]}
              placeHolder={employeeFormLabel["lastName"]}
              error={error["lastName"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"employeeId"}
              value={form.employeeId}
              onChange={onChange}
              label={employeeFormLabel["employeeId"]}
              placeHolder={employeeFormLabel["employeeId"]}
              error={error["employeeId"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"email"}
              type="email"
              value={form.email}
              onChange={onChange}
              label={employeeFormLabel["email"]}
              placeHolder={employeeFormLabel["email"]}
              error={error["email"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"mobileNumber"}
              type="number"
              value={form.mobileNumber}
              onChange={onChange}
              label={employeeFormLabel["mobileNumber"]}
              placeHolder={employeeFormLabel["mobileNumber"]}
              error={error["mobileNumber"]}
            />
          </Col>
          <Col md={4}>
            <FormInput
              name={"aadharNumber"}
              type="number"
              value={form.aadharNumber}
              onChange={onChange}
              label={employeeFormLabel["aadharNumber"]}
              placeHolder={employeeFormLabel["aadharNumber"]}
              error={error["aadharNumber"]}
            />
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{employeeFormLabel["dob"]}</Label>

              <DatePicker
                name={"dob"}
                value={form.dob}
                onChangeDate={onChange}
                label={employeeFormLabel["dob"]}
                placeHolder={employeeFormLabel["dob"]}
                error={error["dob"]}
                initialViewDate={nextYearDateDate}
              />
              <InputError error={error["dob"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{employeeFormLabel["gender"]}</Label>

              <SimpleSelect
                name={"gender"}
                value={form.gender}
                options={employeeGenderList}
                onChange={onChange}
                label="name"
                id="value"
                placeHolder={employeeFormLabel["gender"]}
              />
              <InputError error={error["gender"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            {/* <FormGroup> */}
            {/* <Label>{employeeFormLabel["designation"]}</Label> */}

            {/* <SimpleSelect
                name={"designation"}
                value={form.designation}
                onChange={onChange}
                options={employeeTrainingDesignationList}
                // label={"name"}
                // id="value"
                placeHolder={employeeFormLabel["designation"]}
              /> */}
            <FormInput
              name={"designation"}
              type="text"
              value={form.designation}
              onChange={onChange}
              label={employeeFormLabel["designation"]}
              placeHolder={employeeFormLabel["designation"]}
              error={error["designation"]}
            />
            {/* <InputError error={error["designation"]} />
            </FormGroup> */}
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{employeeFormLabel["dateOfJoining"]}</Label>

              <DatePicker
                name={"dateOfJoining"}
                value={form.dateOfJoining}
                onChangeDate={onChange}
                label={employeeFormLabel["dateOfJoining"]}
                placeHolder={employeeFormLabel["dateOfJoining"]}
                error={error["dateOfJoining"]}
                // disabled={!form.employmentStatus}
                isValidDate={disableFutureDate}
              />
              <InputError error={error["dateOfJoining"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{employeeFormLabel["employmentStatus"]}</Label>
              {/* <SimpleSelect
                name={"employmentStatus"}
                value={form.employmentStatus}
                options={employeeEmploymentStatusList}
                onChange={onChange}
                label="name"
                id="value"
                placeHolder={employeeFormLabel["employmentStatus"]}
                error={error["employmentStatus"]}
              />
              <InputError error={error["employmentStatus"]} /> */}
              <span>Active</span>
            </FormGroup>
          </Col>
        </Row>
      </div>

      {!id && (
        <InitialLocationForm
          siteList={siteList}
          form={form}
          onChange={onChange}
          error={error}
          hideMedicalForm
        />
      )}

      {form.siteType === 3 && (
        <>
          {/* {!id && ( */}
          <InitialTrainingForm
            form={form}
            onChange={onChange}
            error={error}
            id={id}
            previousTraining={previousTraining}
            setPreviousTraining={setPreviousTraining}
            preTrainingErr={preTrainingErr}
          />
          {/* )} */}

          <InitialMedicalForm
            showMedical
            form={form}
            onChange={onChange}
            error={error}
            id={id}
            employeeType={"employee"}
          />
        </>
      )}
    </div>
  );
}

export default EmployeeForm;
